export enum DocumentPriceEnum {
    // Renting Contract Documents
    RentingContract_Pdf = 'full_renting_contract_pdf',
    RentingContract_Odt = 'full_renting_contract_odt',
    RentingContract_Docx = 'full_renting_contract_docx',

    // Inventory Documents
    Inventory_Pdf = 'inventory_pdf',
    Inventory_Odt = 'inventory_odt',
    Inventory_Docx = 'inventory_docx',

    // Sub Renting Contract Documents
    SubRentingContract_Pdf = 'sub_renting_contract_pdf',
    SubRentingContract_Odt = 'sub_renting_contract_odt',
    SubRentingContract_Docx = 'sub_renting_contract_docx',

    // End Contract Documents
    EndContract_Pdf = 'end_contract_pdf',
    EndContract_Odt = 'end_contract_odt',
    EndContract_Docx = 'end_contract_docx',

    // Data Beneficiar Real Contract Documents
    DataBeneficiarRealContract_Pdf = 'data_beneficiar_real_contract_pdf',
    DataBeneficiarRealContract_Odt = 'data_beneficiar_real_contract_odt',
    DataBeneficiarRealContract_Docx = 'data_beneficiar_real_contract_docx',

    // GDPR Acord Documents
    AcordGDPR_Pdf = 'acord_gdpr_pdf',
    AcordGDPR_Odt = 'acord_gdpr_odt',
    AcordGDPR_Docx = 'acord_gdpr_docx'
}

export interface DocumentPriceDetails {
    documentFormat: string;
    documentPrice: number;
    documentCurrency: string;
    documentType: string;
    documentUniqueGroup: string;
    documentUniqueName: string;
}

export const DOCUMENT_PRICES: Record<DocumentPriceEnum, DocumentPriceDetails> = {
    // Renting Contract Documents
    [DocumentPriceEnum.RentingContract_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 6.99,
        documentCurrency: 'RON',
        documentType: 'Renting Contract',
        documentUniqueGroup: 'full_renting_contract',
        documentUniqueName: 'full_renting_contract_pdf'        
    },
    [DocumentPriceEnum.RentingContract_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 6.99,
        documentCurrency: 'RON',
        documentType: 'Renting Contract',
        documentUniqueGroup: 'full_renting_contract',
        documentUniqueName: 'full_renting_contract_odt'
    },
    [DocumentPriceEnum.RentingContract_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 6.99,
        documentCurrency: 'RON',
        documentType: 'Renting Contract',
        documentUniqueGroup: 'full_renting_contract',
        documentUniqueName: 'full_renting_contract_docx'
    },

    // Inventory Documents
    [DocumentPriceEnum.Inventory_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 0.00,
        documentCurrency: 'RON',
        documentType: 'Inventory',
        documentUniqueGroup: 'inventory',
        documentUniqueName: 'inventory_pdf'
    },
    [DocumentPriceEnum.Inventory_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Inventory',
        documentUniqueGroup: 'inventory',
        documentUniqueName: 'inventory_odt'
    },
    [DocumentPriceEnum.Inventory_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Inventory',
        documentUniqueGroup: 'inventory',
        documentUniqueName: 'inventory_docx'
    },

    // Sub Renting Contract Documents
    [DocumentPriceEnum.SubRentingContract_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 0.00,
        documentCurrency: 'RON',
        documentType: 'Sub Renting Contract',
        documentUniqueGroup: 'sub_renting_contract',
        documentUniqueName: 'sub_renting_contract_pdf'
    },
    [DocumentPriceEnum.SubRentingContract_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Sub Renting Contract',
        documentUniqueGroup: 'sub_renting_contract',
        documentUniqueName: 'sub_renting_contract_odt'
    },
    [DocumentPriceEnum.SubRentingContract_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Sub Renting Contract',
        documentUniqueGroup: 'sub_renting_contract',
        documentUniqueName: 'sub_renting_contract_docx'
    },

    // End Contract Documents
    [DocumentPriceEnum.EndContract_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 0.00,
        documentCurrency: 'RON',
        documentType: 'End Contract',
        documentUniqueGroup: 'end_contract',
        documentUniqueName: 'end_contract_pdf'
    },
    [DocumentPriceEnum.EndContract_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'End Contract',
        documentUniqueGroup: 'end_contract',
        documentUniqueName: 'end_contract_odt'
    },
    [DocumentPriceEnum.EndContract_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'End Contract',
        documentUniqueGroup: 'end_contract',
        documentUniqueName: 'end_contract_docx'
    },

    // Data Beneficiar Real Contract Documents
    [DocumentPriceEnum.DataBeneficiarRealContract_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 0.00,
        documentCurrency: 'RON',
        documentType: 'Data Beneficiar Real Contract',
        documentUniqueGroup: 'data_beneficiar_real_contract',
        documentUniqueName: 'data_beneficiar_real_contract_pdf'
    },
    [DocumentPriceEnum.DataBeneficiarRealContract_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Data Beneficiar Real Contract',
        documentUniqueGroup: 'data_beneficiar_real_contract',
        documentUniqueName: 'data_beneficiar_real_contract_odt'
    },
    [DocumentPriceEnum.DataBeneficiarRealContract_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'Data Beneficiar Real Contract',
        documentUniqueGroup: 'data_beneficiar_real_contract',
        documentUniqueName: 'data_beneficiar_real_contract_docx'
    },

    // GDPR Acord Documents
    [DocumentPriceEnum.AcordGDPR_Pdf]: {
        documentFormat: 'PDF',
        documentPrice: 0.00,
        documentCurrency: 'RON',
        documentType: 'GDPR Acord',
        documentUniqueGroup: 'acord_gdpr',
        documentUniqueName: 'acord_gdpr_pdf'
    },
    [DocumentPriceEnum.AcordGDPR_Odt]: {
        documentFormat: 'ODT',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'GDPR Acord',
        documentUniqueGroup: 'acord_gdpr',
        documentUniqueName: 'acord_gdpr_odt'
    },
    [DocumentPriceEnum.AcordGDPR_Docx]: {
        documentFormat: 'DOCX',
        documentPrice: 5.99,
        documentCurrency: 'RON',
        documentType: 'GDPR Acord',
        documentUniqueGroup: 'acord_gdpr',
        documentUniqueName: 'acord_gdpr_docx'
    }
}; 